<template>
  <div class="Container">
    <div :class="['Brick', 'Left', previewtop ? 'Off' : 'On']">
      <div :class="['IconLeft', previewtop ? 'IconOff' : 'IconOn']" />
    </div>
    <div :class="['Brick', 'Right', previewtop ? 'On' : 'Off']">
      <div :class="['IconRight', previewtop ? 'IconOn' : 'IconOff']" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    previewtop: { type: Boolean }
  }
}
</script>

<style scoped>
.Container {
    display: flex;
    flex-direction: row;
    width: auto;
    height: auto;
    z-index: 100;
}

.Brick {
    width: 2.2em;
    height: 2em;
    border: solid 1px rgb(100,100,100);
}

.Left {
    border-radius: 100% 0% 0% 100%;
    display: flex;
}

.Right {
    border-radius: 0% 100% 100% 0%;
    display: flex;
}

.On {
  background: rgb(100,100,100);
}

.Off {
  background: rgba(0,0,0,0);
}

.IconLeft {
  mask-image: url('../../../assets/icons/profile.svg');
  width: 80%;
  height: 80%;
  margin: auto;
  mask-repeat: no-repeat;
  mask-position: center;
  mask-size: contain;
}

.IconRight {
  mask-image: url('../../../assets/icons/dessus.svg');
  width: 80%;
  height: 80%;
  margin: auto;
  mask-repeat: no-repeat;
  mask-position: center;
  mask-size: contain;
}

.IconOff {
  background: rgb(100,100,100);
}

.IconOn {
  background: white;
}
</style>
